/*
 *   File : date-picker.js
 *   Author : https://evoqins.com
 *   Description : date picker component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import DatePicker from 'react-date-picker';
import { format } from 'date-fns';

//custom style
import style from "../../Styles/Component/input.module.scss";

//Custom components
import { OverLay } from '../Others';
import { Icon } from '../Icon';

const CustomDatePicker = (props) => {

    const [selectedDate, setSelectedDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(props.toggle);

    useEffect(() => {

        if (props.selected !== null) {
            setSelectedDate(new Date(props.selected));
        } else {
            setSelectedDate(props.selected);
        }
    }, [props.selected]);

    useEffect(() => {
        setShowDatePicker(props.toggle);
    }, [props.toggle]);

    const _handleOpenDatePicker = () => {
        document.querySelector(".react-date-picker__inputGroup").click();
        props.handleToggle();
    };

    const _handleClosePicker = () => {
        document.querySelector(".react-date-picker__inputGroup").blur();
        props.handleToggle();
    };

    const _handleBlur = (event) => {
        if (showDatePicker && event.target.classList.contains("react-date-picker__inputGroup__input")) {
            document.querySelector(".react-date-picker__inputGroup").click();
        }
    };

    return (
        <div className={props.wrapperClass}>
            {
                props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-alt-font-lato  e-font-weight-500 line-height-20px padding-8px-bottom`}>
                    {props.label}
                    {props.require &&
                        <span className='e-text-vermilion'>*</span>
                    }
                </label>
            }

            <div className='calendar position-relative'>
                <div className={`${props.error && style.e_error_border} ${showDatePicker ? style.e_date_picker_active : style.e_date_picker_inactive} ${props.padding ? props.padding : "padding-12px-lr py-sm-3"} e-padding-8px-all-res d-flex justify-content-between border-radius-8 cursor-pointer`}
                    onClick={_handleOpenDatePicker}>
                    {
                        selectedDate !== null ?
                            <>
                                <p className='mb-0  e-alt-font-lato e-font-14 e-text-chinese-black e-font-weight-600 line-height-18px'>
                                    {format(selectedDate, 'PP')}
                                </p>
                                <div onClick={(event) => event.stopPropagation()}>
                                    <Icon icon="close-icon"
                                        className='cursor-pointer d-flex position-relative z-index-999'
                                        size="16px"
                                        onPress={props.handleClear} />
                                </div>
                            </>
                            :
                            <>
                                <p className='mb-0 e-text-slate-gray e-alt-font-lato e-font-12 e-font-weight-400 line-height-18px'>
                                    {props.placeholder}
                                </p>
                                <Icon icon="calendar"
                                    className="d-flex"
                                    size="16px" />
                            </>
                    }
                </div>

                {
                    props.error &&
                    <p className={`${style.e_error_message} position-absolute mb-0 e-text-vermilion e-alt-font-lato e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                        {props.error}
                    </p>
                }

                {/* Date picker */}
                {
                    showDatePicker &&
                    <>
                        {
                            props.overlay === true &&
                            <OverLay isOpen={showDatePicker} onClose={props.handleClose} />
                        }
                        <Icon icon="close-icon"
                            className='position-absolute m-2 end-0 cursor-pointer z-index-999'
                            size={18}
                            onPress={_handleClosePicker} />
                    </>
                }

                <DatePicker value={selectedDate}
                    isOpen={showDatePicker}
                    calendarProps={{ defaultActiveStartDate: props.startDate }}
                    minDate={props.minDate}
                    maxDate={props.maxDate}
                    onBlur={_handleBlur}
                    className="w-100 position-relative"
                    onCalendarClose={_handleClosePicker}
                    onChange={props.handleSelect} />
            </div>
        </div>

    )
}

export default memo(CustomDatePicker);